module.exports = __webpack_public_path__ + "img/map-hooters.d2259575.png";